import React from 'react';
import NavBar from './NavBar';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';

export default function AppContainer() {
  return (
    <Box className="App">
      <NavBar />
      <Box pt={1} pl={1} pb={2}>
        <Outlet />
      </Box>
    </Box>
  );
}
